import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormControl, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MaintenancesApi } from '@core/api/maintenances/maintenances.api';
import { FcSendEmailMessageDialogComponent } from '@core/components/fc-send-email-message-dialog/fc-send-email-message-dialog.component';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { CompanyReallocateValidation } from '@validators/company-reallocate-validation';
import * as moment from 'moment';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var DialogReallocateMaintenanceComponent = /** @class */ (function () {
    function DialogReallocateMaintenanceComponent(maintenance, matDialog, matDialogRef, fuseTranslationLoaderService, translateService, formBuilder, maintenancesApi) {
        this.maintenance = maintenance;
        this.matDialog = matDialog;
        this.matDialogRef = matDialogRef;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.translateService = translateService;
        this.formBuilder = formBuilder;
        this.maintenancesApi = maintenancesApi;
        this.isUpdate = false;
        this.isSaving = false;
        this.refreshDatatable = false;
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
        this.reallocateMaintenancesForm = this.formBuilder.group({
            id: this.maintenance.id ? this.maintenance.id : null,
            status: this.maintenance.status ? this.maintenance.status : null,
            number: new FormControl({ value: this.maintenance.number, disabled: true }, [Validators.required]),
            type: new FormControl({ value: this.maintenance.maintenanceType && this.maintenance.maintenanceType.name, disabled: true }, [Validators.required]),
            openedDate: new FormControl({ value: moment(this.maintenance.openedAt).toDate(), disabled: true }, [Validators.required]),
            openedTime: new FormControl({ value: moment(this.maintenance.openedAt).format('HH:mm'), disabled: true }, [Validators.required]),
            message: new FormControl(null, [Validators.required]),
            newCompany: new FormControl(null, [Validators.required]),
            company: new FormControl({ value: this.maintenance.company, disabled: true }, [Validators.required]),
            segment: new FormControl({ value: this.maintenance.segment, disabled: true }, [Validators.required]),
            companyScheduleSuggestion: this.maintenance.companyScheduleSuggestion ? this.maintenance.companyScheduleSuggestion : null,
            scheduleSuggestions: this.maintenance.scheduleSuggestions && this.maintenance.scheduleSuggestions.length > 0 ? new FormArray(this.maintenance.scheduleSuggestions.map(function (scheduleSuggestion) { return new FormControl(scheduleSuggestion); })) : new FormArray([]),
            scheduleSuggestionsStatus: this.maintenance.scheduleSuggestionsStatus ? this.maintenance.scheduleSuggestionsStatus : null
        }, {
            validator: CompanyReallocateValidation.validate
        });
        this.locationAddressCoords = maintenance.location && maintenance.location.address && maintenance.location.address.coords;
    }
    DialogReallocateMaintenanceComponent.prototype.ngOnDestroy = function () {
        this.matDialogRef.close(this.refreshDatatable);
    };
    DialogReallocateMaintenanceComponent.prototype.reallocateMaintenance = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, value, reallocate;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.matDialog.open(FcSendEmailMessageDialogComponent, {
                            data: {
                                title: this.translateService.instant('DIALOG_REALLOCATE_MAINTENANCE.TITLE'),
                                okText: this.translateService.instant('DIALOG_REALLOCATE_MAINTENANCE.OK_TEXT'),
                                notOkText: this.translateService.instant('DIALOG_REALLOCATE_MAINTENANCE.NOT_OK_TEXT'),
                                cancelText: this.translateService.instant('DIALOG_REALLOCATE_MAINTENANCE.CANCEL_TEXT'),
                                message: this.translateService.instant('DIALOG_REALLOCATE_MAINTENANCE.MESSAGE'),
                                inputLabel: this.translateService.instant('DIALOG_REALLOCATE_MAINTENANCE.INPUT_LABEL'),
                            }
                        }).afterClosed()
                            .toPromise()];
                    case 1:
                        result = _a.sent();
                        if (result) {
                            this.isSaving = true;
                            value = this.reallocateMaintenancesForm.value;
                            reallocate = {
                                message: value.message,
                                sendEmail: result.sendEmail,
                                sendEmailMessage: result.message || '',
                                newCompanyId: value.newCompany && value.newCompany.id,
                                scheduleSuggestions: value.scheduleSuggestions.map(function (scheduleSuggestion) {
                                    var date = moment.utc(scheduleSuggestion.date).format('YYYY-MM-DD');
                                    return { date: date, time: scheduleSuggestion.time };
                                })
                            };
                            this.maintenancesApi
                                .reallocateMaintenance(this.maintenance.id, reallocate)
                                .subscribe(function () {
                                _this.isSaving = false;
                                _this.refreshDatatable = true;
                                _this.matDialogRef.close(true);
                            });
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return DialogReallocateMaintenanceComponent;
}());
export { DialogReallocateMaintenanceComponent };
